export default __webpack_public_path__ + "static/media/dinosaurs.ea53abf3.jpeg";